import HTTP from '@/common/HTTP'

import {actionTypes, mutationTypes} from './DatenpoolFilesTypes';

// initial state
const initialState = () => ({
  loading: false, items: []
})

// getters
const getters = {}

// mutations
const mutations = {
  [mutationTypes.SET_LOADING](state, item) {
    state.loading = item
  },

  [mutationTypes.SET_FILES](state, item) {
    state.items = item
  },
}

// actions
const actions = {
  async [actionTypes.FETCH_FILES]({commit, dispatch}) {
    commit(mutationTypes.SET_LOADING, true)

    try {
      const result = await HTTP.get('/datenpool')
      console.log(result)

      commit(mutationTypes.SET_FILES, result.data.content)
    } catch (e) {
      console.error(e)

      this._vm.$notify({
        group: 'app',
        title: 'Fehler',
        type: 'error',
        text: 'Fehler beim Laden der Dateien.',
        duration: 3000
      })
      commit(mutationTypes.SET_FILES, [])
    }

    commit(mutationTypes.SET_LOADING, false)
  },

  async [actionTypes.DELETE_FILE]({commit, dispatch}, file) {
    commit(mutationTypes.SET_LOADING, true)

    try {
      const result = await HTTP.delete(`datenpool/${file.id}/delete`);
      console.log(result);

      this._vm.$notify({
        group: 'app',
        type: 'success',
        title: 'Erfolgreich',
        text: `Die Datei ${file.fileName} wurde erfolgreich gelöscht.`,
        duration: 3000
      });
    } catch (e) {

      this._vm.$notify({
        group: 'app',
        type: 'error',
        title: 'Erfolgreich',
        text: `Die Datei ${file.fileName} konnte nicht gelöscht werden.`,
        duration: 3000
      });
    }
    commit(mutationTypes.SET_LOADING, false)

    dispatch(actionTypes.FETCH_FILES)
  },

  async [actionTypes.UPDATE_FILE_CATEGORY]({commit, dispatch}, file) {
    commit(mutationTypes.SET_LOADING, true)

    try {
      await HTTP.post(`datenpool/${file.id}/updateCategory`, {categories: file.categories});

    } catch (e) {
      console.error(e);

      this._vm.$notify({
        group: 'app',
        title: 'Fehler',
        type: 'error',
        text: 'Fehler beim Aktualisieren der Kategorie.',
        duration: 3000
      })
    }

    dispatch(actionTypes.FETCH_FILES)

    commit(mutationTypes.SET_LOADING, false)
  },

  async [actionTypes.UPDATE_FILENAME]({commit, dispatch}, file) {
    commit(mutationTypes.SET_LOADING, true)

    try {
      await HTTP.post(`datenpool/${file.id}/updateFilename`, {fileName: file.fileName});

    } catch (e) {
      console.error(e);

      this._vm.$notify({
        group: 'app',
        title: 'Fehler',
        type: 'error',
        text: 'Fehler beim Aktualisieren des Dateinamens.',
        duration: 3000
      })
    }

    dispatch(actionTypes.FETCH_FILES)

    commit(mutationTypes.SET_LOADING, false)
  },

  async [actionTypes.UPDATE_FILE_TAGS]({commit, dispatch}, file) {
    commit(mutationTypes.SET_LOADING, true)

    try {
      await HTTP.post(`datenpool/${file.id}/updateTags`, {tags: file.tags});

    } catch (e) {
      console.error(e)

      this._vm.$notify({
        group: 'app',
        title: 'Fehler',
        type: 'error',
        text: 'Fehler beim Aktualisieren der Schlagwörter.',
        duration: 3000
      })
    }

    dispatch(actionTypes.FETCH_FILES)

    commit(mutationTypes.SET_LOADING, false)
  },

  async [actionTypes.DOWNLOAD_FILE]({commit, dispatch}, file) {
    commit(mutationTypes.SET_LOADING, true)

    try {
      const response = await HTTP.get(`datenpool/${file.id}/download`, { responseType: 'blob' });
      console.log(response);

      const url = window.URL.createObjectURL(new Blob([response.data]))
      const link = document.createElement('a')

      link.href = url
      link.setAttribute('download', file.fileName)

      document.body.appendChild(link)
      link.click();

      this._vm.$notify({
        group: 'app',
        title: 'Erfolgreich',
        type: 'success',
        text: `Die Datei ${file.fileName} wurde erfolgreich heruntergeladen.`,
        duration: 3000
      })
    } catch (e) {
      console.error(e)

      this._vm.$notify({
        group: 'app',
        title: 'Fehler',
        type: 'error',
        text: `Die Datei ${file.fileName} konnte nicht heruntergeladen werden.`,
        duration: 3000
      })
    }

    commit(mutationTypes.SET_LOADING, false)
  }
}

export default {
  namespaced: true,
  state: initialState,
  actions,
  mutations,
  getters
}



// WEBPACK FOOTER //
// ./src/store/modules/DatenpoolFiles.js